module.exports = __webpack_public_path__ + "static/media/sb-info.cce1ac51.svg";